export default {"src":"/_next/static/media/logotype-visitsweden-footer.4d26c3ba.svg","height":40,"width":82,"blurWidth":0,"blurHeight":0};